import { getBrowserAndDeviceInfo } from '@/utils/device.js';

export const registerServiceWorkerAudio = async () => {
  const client = getBrowserAndDeviceInfo();
  const isChrome = client.browser === 'Chrome';
  const isSafari = client.browser === 'Safari';

  // 음성파일 캐싱을 위한 service worker 등록
  if ('serviceWorker' in navigator) {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));

    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map((n) => caches.delete(n)));
    }
    if (!isChrome && !isSafari) return;
    navigator.serviceWorker.register('/serviceWorkerAudio.js', {
      updateViaCache: 'none',
    });
  }
};
